export enum StatusSchedulingEnum {
    Pendente = 1,
    AAprazar = 2,
    Aprazado = 3,
    Concluido = 4,
    Atrasado = 5,
    Suspenso = 6,
    Agora = 7,
}